/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const chat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.734 8.467-1.867 1.866V7.207A3.26 3.26 0 0 1 4.267 1h1.867a3.268 3.268 0 0 1 3.131 2.333M15 8.933a3.266 3.266 0 0 0-3.267-3.266H9.867a3.266 3.266 0 0 0 0 6.533h.467l2.8 2.8v-3.126A3.259 3.259 0 0 0 15 8.934Z"
    />
  </svg>
)
export default chat
